// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1654":"936f9f14","2362":"936f9f14","6771":"936f9f14","7716":"a20ade8d"}[chunkId] + ".chunk.css";
};